<template>
  <svg width="20" height="18" viewBox="0 0 20 18">
    <path
      fill="white"
      fill-rule="nonzero"
      d="M2 2h3l2-2h6l2 2h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm8 3a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"
    />
  </svg>
</template>
